<template>
  <div v-once class="component-barcode-scanner">
    <svg class="dbrScanner-bg-loading" viewBox="0 0 1792 1792"><path d="M1760 896q0 176-68.5 336t-184 275.5-275.5 184-336 68.5-336-68.5-275.5-184-184-275.5-68.5-336q0-213 97-398.5t265-305.5 374-151v228q-221 45-366.5 221t-145.5 406q0 130 51 248.5t136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5q0-230-145.5-406t-366.5-221v-228q206 31 374 151t265 305.5 97 398.5z"/></svg>
    <svg class="dbrScanner-bg-camera" style="display:none;" viewBox="0 0 2048 1792"><path d="M1024 672q119 0 203.5 84.5t84.5 203.5-84.5 203.5-203.5 84.5-203.5-84.5-84.5-203.5 84.5-203.5 203.5-84.5zm704-416q106 0 181 75t75 181v896q0 106-75 181t-181 75h-1408q-106 0-181-75t-75-181v-896q0-106 75-181t181-75h224l51-136q19-49 69.5-84.5t103.5-35.5h512q53 0 103.5 35.5t69.5 84.5l51 136h224zm-704 1152q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"/></svg>
    <video class="dbrScanner-video" playsinline="true"></video>
    <canvas class="dbrScanner-cvs-drawarea"></canvas>
    <div class="dbrScanner-cvs-scanarea">
        <div class="dbrScanner-scanlight" style="display:none;"></div>
    </div>
    <select class="dbrScanner-sel-camera camera primary-color"></select>
    <!-- <select class="dbrScanner-sel-resolution"></select> -->
    <el-button @click="closeScanner" icon="el-icon-close" class="button-close primary-color"></el-button>
  </div>
</template>

<script>
/* eslint-disable */
import DBR from './dbr'
import {Button} from 'element-ui'

export default {
  components: {
    [Button.name]: Button
  },
  data () {
    return {
      bDestroyed: false,
      scanner: null,
      DLAbbrDesMap: {
        'DCA': 'Jurisdiction-specific vehicle class',
        'DBA': 'Expiry Date',
        'DCS': 'Last Name',
        'DAC': 'First Name',
        'DBD': 'Issue Date',
        'DBB': 'Birth Date',
        'DBC': 'Gender',
        'DAY': 'Eye Color',
        'DAU': 'Height',
        'DAG': 'Street',
        'DAI': 'City',
        'DAJ': 'State',
        'DAK': 'Zip',
        'DAQ': 'License Number',
        'DCF': 'Document Discriminator',
        'DCG': 'Issue Country',
        'DAH': 'Street 2',
        'DAZ': 'Hair Color',
        'DCI': 'Place of birth',
        'DCJ': 'Audit information',
        'DCK': 'Inventory Control Number',
        'DBN': 'Alias / AKA Family Name',
        'DBG': 'Alias / AKA Given Name',
        'DBS': 'Alias / AKA Suffix Name',
        'DCU': 'Name Suffix',
        'DCE': 'Physical Description Weight Range',
        'DCL': 'Race / Ethnicity',
        'DCM': 'Standard vehicle classification',
        'DCN': 'Standard endorsement code',
        'DCO': 'Standard restriction code',
        'DCP': 'Jurisdiction-specific vehicle classification description',
        'DCQ': 'Jurisdiction-specific endorsement code description',
        'DCR': 'Jurisdiction-specific restriction code description',
        'DDA': 'Compliance Type',
        'DDB': 'Card Revision Date',
        'DDC': 'HazMat Endorsement Expiration Date',
        'DDD': 'Limited Duration Document Indicator',
        'DAW': 'Weight(pounds)',
        'DAX': 'Weight(kilograms)',
        'DDH': 'Under 18 Until',
        'DDI': 'Under 19 Until',
        'DDJ': 'Under 21 Until',
        'DDK': 'Organ Donor Indicator',
        'DDL': 'Veteran Indicator',
        // old standard
        'DAA': 'Customer Full Name',
        'DAB': 'Customer Last Name',
        'DAE': 'Name Suffix',
        'DAF': 'Name Prefix',
        'DAL': 'Residence Street Address1',
        'DAM': 'Residence Street Address2',
        'DAN': 'Residence City',
        'DAO': 'Residence Jurisdiction Code',
        'DAR': 'License Classification Code',
        'DAS': 'License Restriction Code',
        'DAT': 'License Endorsements Code',
        'DAV': 'Height in CM',
        'DBE': 'Issue Timestamp',
        'DBF': 'Number of Duplicates',
        'DBH': 'Organ Donor',
        'DBI': 'Non-Resident Indicator',
        'DBJ': 'Unique Customer Identifier',
        'DBK': 'Social Security Number',
        'DBM': 'Social Security Number',
        'DCH': 'Federal Commercial Vehicle Codes',
        'DBR': 'Name Suffix',
        'PAA': 'Permit Classification Code',
        'PAB': 'Permit Expiration Date',
        'PAC': 'Permit Identifier',
        'PAD': 'Permit IssueDate',
        'PAE': 'Permit Restriction Code',
        'PAF': 'Permit Endorsement Code',
        'ZVA': 'Court Restriction Code',
        'DAD': 'Middle Name'
      }
    }
  },
  methods: {
    closeScanner () {
      this.$emit('closeScanner')
    },
    parseDriverLicense (txt) {
      let lines = txt.split('\n')
      let abbrs = Object.keys(this.DLAbbrDesMap)
      let map = {};
      lines.forEach((line, i) => {
          let abbr
          let content
          if(i === 1){
              abbr = 'DAQ'
              content = line.substring(line.indexOf(abbr) + 3)
          }else{
              abbr = line.substring(0, 3)
              content = line.substring(3).trim()
          }
          if(abbrs.includes(abbr)){
              map[abbr] = {
                  description: this.DLAbbrDesMap[abbr],
                  content: content
              };
          }
      });
      return map;
    }
  },
  async mounted () {
    try {
      this.scanner = await DBR.BarcodeScanner.createInstance()
      this.scanner.bPlaySoundOnSuccessfulRead = true;

      if (this.bDestroyed) {
        this.scanner.destroy()
        return
      }

      await this.scanner.setUIElement(this.$el)
      // this.scanner.onFrameRead = results => {
      //   if (results.length) {
      //     console.log(results)
      //   }
      // }
      let runtimeSettings = await this.scanner.getRuntimeSettings()
      runtimeSettings.barcodeFormatIds = DBR.EnumBarcodeFormat.BF_PDF417
      runtimeSettings.localizationModes = [2,8,0,0,0,0,0,0]
      runtimeSettings.scaleUpModes = [2,4,0,0,0,0,0,0]
      runtimeSettings.scaleDownThreshold = 7000
      runtimeSettings.deblurLevel = 9
      await this.scanner.updateRuntimeSettings(runtimeSettings)

      this.scanner.onFrameRead = results => {
          if(results.length) {
          //  console.log(results)
          }
      }
      this.scanner.onUnduplicatedRead = txt => {
          let licenseInfo = this.parseDriverLicense(txt)
          let data = {}
          data.firstName = licenseInfo.DAC.content
          data.lastName = licenseInfo.DCS.content
          data.dob = licenseInfo.DBB.content
          data.gender = licenseInfo.DBC.content
          data.address = licenseInfo.DAG.content + ', ' + licenseInfo.DAI.content + ', ' + licenseInfo.DAJ.content + ', ' + licenseInfo.DAK.content
          if (licenseInfo.DAH) {
            data.address2 = licenseInfo.DAH.content
          }
          this.$emit('getScannedData', data);
      }

      // this.scanner.onUnduplicatedRead = (txt, result) => {
      //   this.$emit('appendMessage', result.barcodeFormatString + ': ' + txt)
      // }

      await this.scanner.open()
      this.scanner.play()
      // await this.scanner.open()
    } catch (ex) {
      this.$emit('appendMessage', ex.message)
      console.error(ex)
    }
  },
  beforeDestroy () {
    this.bDestroyed = true
    if (this.scanner) {
      this.scanner.destroy()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* .component-barcode-scanner{width:100%;height:100%;min-width:640px;min-height:480px;background:#eee;position:relative;resize:both;} */
.dbrScanner-bg-loading{animation:1s linear infinite dbrScanner-rotate;width:40%;height:40%;position:absolute;margin:auto;left:0;top:0;right:0;bottom:0;fill:#aaa;}
.dbrScanner-bg-camera{width:40%;height:40%;position:absolute;margin:auto;left:0;top:0;right:0;bottom:0;fill:#aaa;}
/* .dbrScanner-video{width:100%;height:100%;position:absolute;left:0;top:0;} */
/* .dbrScanner-cvs-drawarea{width:100%;height:100%;position:absolute;left:0;top:0;} */
.dbrScanner-cvs-scanarea{width:100%;height:100%;position:absolute;left:0;top:0;}
.dbrScanner-scanlight{width:100%;height:3%;position:absolute;animation:3s infinite dbrScanner-scanlight;border-radius:50%;box-shadow:0px 0px 2vw 1px #00e5ff;background:#fff;}
.dbrScanner-sel-camera{margin:0 auto;position:absolute;left:0;top:0;}
.dbrScanner-sel-resolution{position:absolute;left:0;top:20px;}
@keyframes dbrScanner-rotate{from{transform:rotate(0turn);}to{transform:rotate(1turn);}}
@keyframes dbrScanner-scanlight{from{top:0;}to{top:97%;}}


.component-barcode-scanner {
  width: 100%;
  height: 100%;
  /*min-width: 640px;*/
  min-height: 150px;
  background: #eee;
  position: relative;
  resize: both;
}
.dbrScanner-video {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  object-fit: cover;
}
.dbrScanner-cvs-drawarea {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.dbrScanner-cvs-scanarea{
  width: 100% !important;
  left: 0 !important;
}

.button-close{
  float: right;
  position: inherit;
  background: transparent !important;
  border: none !important;
  font-size: 35px !important;
}

.camera{
  background: transparent;
  padding: 5px;
  border-color: red;
  border-radius: 5px;
}
@media only screen and (max-width: 500px) {
  .button-close {
    margin-right: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Patient/Wizard/BarcodeScanner.vue